import React from "react";
import { Form } from "antd";
import ImageUpload from "../../../components/image-upload/ImageUpload";

export default function MediaSection() {
  return (
    <Form.Item name="imageUrl" label="Зураг">
      <ImageUpload size={120} />
    </Form.Item>
  );
}
